import { motion } from "framer-motion";
import PublicLayout from '../templates/PublicLayout';
import CardCompanyIntro from '../components/CardCompanyIntro';
import CardAppIntroduction from '../components/CardAppIntroduction';
import CardStartNow from '../components/CardStartNow';
import CardTeamMembers from '../components/CardTeamMembers';
import CardConsulting from '../components/CardConsulting';
import CardWhatsApp from '../components/CardWhatsApp';
import CardGetStarted from '../components/CardGetStarted';
import { useAuth } from '../context/AuthProvider';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';

const Home = () => {
  const { user } = useAuth();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Início | Fonoaudiologia na Prática";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PublicLayout>
      {/* CardGetStarted */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <CardGetStarted />
      </motion.div>
      <hr className='' />

      {/* CardAppIntroduction */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <CardAppIntroduction />
      </motion.div>
      <hr className='' />

      {/* CardCompanyIntro */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <CardCompanyIntro />
      </motion.div>
      <hr className='' />

      {/* CardTeamMembers */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        viewport={{ once: true }}
      >
        <CardTeamMembers />
      </motion.div>
      <hr className='' />

      {/* CardStartNow */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        viewport={{ once: true }}
      >
        <CardStartNow />
      </motion.div>
      <hr className='' />

      {/* CardConsulting */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1 }}
        viewport={{ once: true }}
      >
        <CardConsulting />
      </motion.div>
      <hr className='' />

      {/* CardWhatsApp */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.2 }}
        viewport={{ once: true }}
      >
        <CardWhatsApp />
      </motion.div>
      <hr className='' />
    </PublicLayout>
  );
};

export default Home;
